<header class="premium-header">
  <!-- Hamburger — visible on mobile only, toggles sidebar drawer -->
  <button class="hamburger-btn" (click)="toggleSidebar.emit()" aria-label="Open navigation menu">
    <i class="fa-solid fa-bars"></i>
  </button>

  <div class="header-left">
    <img src="assets/odisha-logo.png" alt="Government of Odisha" class="gov-logo">
    <div class="page-title">
      <h2>Dashboard Overview</h2>
      <p>Dhamnagar Assembly Constituency</p>
    </div>
  </div>

  <div class="header-center">
    <div class="last-update">
      <i class="fa-regular fa-clock"></i>
      <div class="update-info">
        <span class="lbl">LAST UPDATED</span>
        <span class="val">{{ currentTime() | date:'mediumDate' }}, {{ currentTime() | date:'shortTime' }}</span>
      </div>
    </div>
  </div>

  <div class="header-right">
    <div class="user-profile-section" *ngIf="currentUser()">
      <div class="user-info-wrap">
        @if (avatarUrl(); as src) {
          <img [src]="src" alt="Profile" class="profile-avatar">
        } @else {
          <div class="profile-avatar profile-avatar-fallback" aria-hidden="true">{{ avatarInitial() }}</div>
        }
        <div class="profile-text">
          <span class="name">{{ displayName() }}</span>
          <span class="designation">{{ designation() }}</span>
          <span class="role-badge">{{ roleBadge() }}</span>
        </div>
      </div>
      
      <button class="btn-logout-compact" (click)="confirmLogout()" [disabled]="isLoggingOut()" title="Logout">
        <i class="fa-solid fa-power-off" *ngIf="!isLoggingOut()"></i>
        <i class="fa-solid fa-spinner animate-spin" *ngIf="isLoggingOut()"></i>
      </button>
    </div>
    
    <!-- Logout Confirmation Overlay remains the same -->
  </div>

  <!-- Logout Confirmation Overlay -->
  <div class="logout-confirm-overlay" *ngIf="showLogoutConfirm()">
    <div class="confirm-card">
      <div class="confirm-icon-ring"><i class="fa-solid fa-arrow-right-from-bracket"></i></div>
      <h3>Confirm Logout</h3>
      <p>Are you sure you want to exit the Dhamnagar D3 system?</p>
      <div class="confirm-actions">
        <button class="btn-cancel" (click)="cancelLogout()">Cancel</button>
        <button class="btn-confirm" (click)="logout()" [disabled]="isLoggingOut()">
          {{ isLoggingOut() ? 'Signing Out...' : 'Yes, Logout' }}
        </button>
      </div>
    </div>
  </div>
</header>
